export var Status;
(function (Status) {
    Status["ORDER_PLACED"] = "ORDERED";
    Status["PROCESSING"] = "PROCESSING";
    Status["OPEN"] = "OPEN";
    Status["PACKED"] = "PACKED";
    Status["READY"] = "READY";
    Status["IN_TRANSIT"] = "IN-TRANSIT";
    Status["DELIVERY"] = "DELIVERY";
    Status["DELIVERED"] = "DELIVERED";
    Status["FULFILLED"] = "FULFILLED";
})(Status || (Status = {}));
